import {
  AcademicStanding,
  ConductCaseSeverity,
} from '@sandtech-hub-monorepo/ehub-client';

const LABELS: Record<string, string> = {
  [ConductCaseSeverity.ScholasticWarning]: 'Academic warning',
  [ConductCaseSeverity.AcademicProbation]: 'Academic probation',
  [ConductCaseSeverity.AcademicSuspension]: 'Academic suspension',
  [ConductCaseSeverity.AcademicDismissal]: 'Enrollment withdrawn',
  [AcademicStanding.GoodAcademicStanding]: 'Good academic standing',
};

export const getSeverityLabel = (
  level: AcademicStanding | ConductCaseSeverity
): string => LABELS[level] ?? '';
